<template>
    <el-dialog :title="pledgeLetter.title" :visible.sync="user.agreeDlog" width="400px" center>
        <div v-html="pledgeLetter.content"></div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleAgree">我同意</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { clauseGet, userAgree } from '@/api/index'
export default {
  name: 'PledgeLetter',
  computed: mapState(['user']),
  data () {
    return {
      loading: false,
      pledgeLetter: {
        title: '--',
        content: '--'
      }
    }
  },
  mounted () {
    this.loadClause()
  },
  methods: {
    // 获得承诺书
    loadClause () {
      clauseGet({
        type: 2,
        roleType: 1
      }).then(res => {
        this.pledgeLetter = res.data
      })
    },
    handleAgree () {
      userAgree().then(res => {
        this.$message({
          message: '您已同意',
          type: 'success'
        })
        this.upDateUser()
      })
    },
    upDateUser () {
      this.$store.dispatch('user/getInfo').then(() => {
        this.loading = false
        this.$store.dispatch('user/checkAgree')
      }).catch(() => {
        this.loading = false
      })
    },
    handleClose (done) {
      done()
    }
  }
}
</script>

<style lang="scss" scoped></style>
